<template>
  <v-dialog
    v-model="show"
    max-width="800px"
  >
    <v-form ref="form" v-model="valid" lazy-validation :disabled="loading" @submit="saveScenario" onsubmit="return false;">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ isNew ? $t('editor.scenario.create') :  $t('editor.scenario.update') }}</span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="show = false"
          >
          <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
              >
                <input-scenario
                  :available-elements.sync="elements"
                  :elements.sync="scenarioForm.elements"
                  @scenario-updated="onScenarioUpdated"
                  v-on="$listeners"
                />
              </v-col>
            </v-row>
            <v-row v-if="!isNew">
              <v-col cols="12">
                <div>{{ $t('editor.createdBy') }} <strong>{{ scenarioForm.createdBy }}</strong>, {{ $t('editor.the') }} <strong>{{ new Date(scenarioForm.createdDate).toLocaleString() }}</strong></div>
                <div>{{ $t('editor.lastModifiedBy') }}  <strong>{{ scenarioForm.lastModifiedBy }}</strong>, {{ $t('editor.the') }} <strong>{{ new Date(scenarioForm.lastModifiedDate).toLocaleString() }}</strong></div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn 
            v-if="!isNew"
            @click="deleteScenario"
            :disabled="loading"
            class="raison-btn"
            alt="delete scenario"
          >
            <v-icon>
              mdi-trash-can-outline
            </v-icon>
            {{ $t('editor.scenario.delete') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            type="submit"
            class="raison-btn"
            :disabled="loading || !valid"
          >
            <v-icon>
              mdi-content-save-outline
            </v-icon>
          {{ $t('editor.scenario.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import scenarioService from '@/services/scenarios.js'

import InputScenario from '@/components/editor/InputScenario'

export default ({
  name: 'ScenarioForm',

  components: {
    InputScenario,
  },

  mixins: [ ],

  data () {
    return {
      loading: false,
      scenarioForm: { elements: [] },
      logicalLanguageLoading: false,
      valid: false,
    }
  },

  watch: {
    scenario: function(scenario) {
      this.scenarioForm = {
        ...this.scenarioForm,
        ...JSON.parse(JSON.stringify(scenario))
      }
    },
  },

  props: {
    open: {
      type: Boolean,
      required: true,
    },
    elements: {
      type: Array,
      required: true
    },
    scenario: {
      type: Object,
      required: false,
      default: () => { [] }
    }
  },
  
  computed: {
    isNew() {
      return !this.scenarioForm.id
    },
    show: {
      get () {
          return this.open;
      },
      set (value) {
        // if(!value) {
        //   this.onCancel()
        // }
        this.$emit('update:open', value);
      }
    }
  },

  methods: {
    emptyScenarioForm() {
      return { elements: [] }
    },
    onScenarioUpdated(elements) {
      this.scenarioForm.elements.splice(0, elements.length, ...elements)
      console.log('onScenarioUpdated', elements, this.scenarioForm.elements)
    },
    updateElementList(newElements) {
      // call back due to bad design of the input-scenario-elements component
      this.elements.splice(0, this.elements.length, ...newElements);
    },
    saveScenario(event) {
      event.preventDefault()
      if(!this.$refs.form.validate()) {
        return
      }
      if(this.isNew) {
        this.createScenario()
      }
      else {
        this.updateScenario()
      }
    },
    createScenario() {
      console.log('createScenario', this.scenarioForm)
      this.loading = true
      const projectId = this.$route.params.id
      this.show = false
      scenarioService.createMinimalScenario(projectId, this.scenarioForm.elements.map(elt => elt.id))
        .then(response => {
          this.clearForm()
          this.$emit("scenarioCreated", response.data)
          this.show = false
        })
        .catch(err => {
          this.$emit('raison-event', { type: 'error', messages: [err] })
        })
        .finally(() => {
          this.reset()
          this.loading = false
        })
    },
    updateScenario() {
      this.loading = true
      const projectId = this.$route.params.id
      console.log('updateScenario', this.scenarioForm)
      this.show = false
      const newScenario = JSON.parse(JSON.stringify(this.scenarioForm))
      scenarioService.updateScenario(projectId, newScenario)
        .then(response => {
          this.$emit("scenarioUpdated", response.data)
          this.show = false
        })
        .catch(err => {
          this.$emit('raison-event', { type: 'error', messages: [err] })
        })
        .finally(() => {
          this.reset()
          this.loading = false
        })
    },
    deleteScenario() {
      this.loading = true
      const projectId = this.$route.params.id
      console.log("deleteScenario", projectId, this.scenarioForm.id)
      const scenarioToDelete = this.scenario
      scenarioService.deleteMinimalScenario(projectId, scenarioToDelete.id)
        .then(() => {
          this.$emit("scenarioDeleted", scenarioToDelete)
          this.show = false
        })
        .catch(err => {
          this.$emit('raison-event', { type: 'error', messages: [err] })
        })
        .finally(() => {
          this.reset()
          this.loading = false
        })
    },
    onCancel() {
      console.log('onCancel', this.scenarioForm)
      this.reset()
    },
    reset() {
      if(this.scenario) {
        this.scenarioForm = { ...JSON.parse(JSON.stringify(this.scenario)) }
      }
      this.$refs.form.resetValidation()
    },
    clearForm() {
      console.log('clearForm')
      this.scenarioForm = { elements: [] }
    }
  },

});
</script>
<style scoped>
</style>